// Время сервера на устройстве игрока. Часы телефона могут отставать или спешить на секунды и минуты —
// тогда походы «стоят» после отправки и таймеры врут. Каждый ответ API несёт X-Server-Time; поправка
// сглаживается и применяется к анимации карты, таймерам и прогрессу походов.
let offset = 0;
let samples = 0;

/** Учесть время сервера из ответа (sentAt/receivedAt — когда ушёл запрос и пришёл ответ, по часам устройства). */
export function noteServerTime(serverMs: number, sentAt: number, receivedAt: number): void {
  if (!Number.isFinite(serverMs) || serverMs <= 0) return;
  const rtt = Math.max(0, receivedAt - sentAt);
  // Медленный ответ — неточная оценка: такие пропускаем, кроме самых первых
  if (rtt > 3000 && samples > 0) return;
  const estimate = serverMs + rtt / 2 - receivedAt;
  offset = samples === 0 ? estimate : offset * 0.8 + estimate * 0.2;
  samples++;
}

/** Текущее время по часам сервера, мс. */
export function serverNow(): number {
  return Date.now() + offset;
}

/** Поправка часов устройства, мс (для отладки). */
export function serverOffset(): number {
  return offset;
}
